// extracted by mini-css-extract-plugin
module.exports = {"container":"Navbar_container__bHAeH","navbar":"Navbar_navbar__zHpdT","link":"Navbar_link__dx5xg","rightSlot":"Navbar_rightSlot__BpGrf","centerSlot":"Navbar_centerSlot__cuxQJ"};